import { render, staticRenderFns } from "./DeptCreate.vue?vue&type=template&id=3df7d307&scoped=true&"
import script from "./DeptCreate.vue?vue&type=script&lang=js&"
export * from "./DeptCreate.vue?vue&type=script&lang=js&"
import style0 from "./DeptCreate.vue?vue&type=style&index=0&id=3df7d307&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df7d307",
  null
  
)

export default component.exports